(function(){

        'use strict';

        // **********************************
        //  Data that this directive needs
        // ----------------------------------
        //
        //

        function pxApplicationDirective(
        $timeout, $filter, toastr, $http, ApplicationsService, RegexModel,
        $rootScope
        ) {
        return {
            restrict: 'EA',
            scope: {
            context: '=context',
            tenant: '=tenant',
            state: '=state',
            meta: '=meta',
            callback: '&callback'
            },
            templateUrl: 'app/components/applications/application/application.template.html',
            link: function(scope) {

                function ApplicationFormModel () {
                    this.name = '';
                    this.type = 'CLOUD_PRINT';
                    return this;
                }

                scope.nameValidator      = new RegexModel().badNameString();
                scope.illegalChars       = new RegexModel().badNameString().string;
                scope.SECRET_ROTATION    = false;
                scope.CREATING           = false;
                scope.secret_PLACEHOLDER = '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -';
                var applicationOriginal  = null;


                (() => {
                    setState(scope.state)
                })();

                function setState (state){
                    switch (state) {
                        case 'CREATE':
                            scope.application = new ApplicationFormModel();
                            scope.terms       = {accepted: false};
                            scope.nameInvalid = false;
                            scope.illegalName = false;
                            scope.formInvalid = true;
                        break;
                        case 'MODIFY':
                            scope.terms         = {accepted: true};
                            scope.application   = angular.copy(scope.context.data);
                            applicationOriginal = angular.copy(scope.context.data);
                        break;
                        case 'CREATE_SECRET':
                            scope.application = angular.copy(scope.context.data);
                        break;
                    }
                }


                ////////////////////////////////////////////
                // Form validation
                ////////////////////////////////////////////
                function validateForm (name) {
                    validateName(name);
                    if (!scope.terms.accepted || scope.nameInvalid) {
                        scope.formInvalid = true;
                    } else {
                        scope.formInvalid = false;
                    }
                }

                function validateName (name) {
                    if (!name) {
                        scope.nameInvalid = true;
                        scope.illegalName = false;
                    } else {
                        scope.nameInvalid = name.match(scope.nameValidator.regex);
                        scope.illegalName = scope.nameInvalid;
                    }
                }

                scope.validateForm = () => {
                    var name = scope.application.name || scope.application.info.name
                    validateForm(name)
                }



                ////////////////////////////////////////////
                // Crud operations
                ////////////////////////////////////////////
                scope.create = () => {
                    scope.CREATING = true;
                    ApplicationsService.create(scope.application).then((application) => {
                        scope.application = application;
                        var message = $filter("translate")("ApplicationCreated") + ': ' + scope.application.info.name;
                        toastr.success(message);
                        $rootScope.$broadcast('APPLICATION_RELOAD_PAGE');
                    }).catch( (error) => {
                        toastr.error($filter('translate')('Error'));
                    });
                }

                scope.update = () => {
                    console.log('scope.application', scope.application);
                    scope.application.update(applicationOriginal, scope.application).then(() => {
                        toastr.success('ChangesSaved');
                        $rootScope.$broadcast('APPLICATION_RELOAD_PAGE');
                        scope.callback();
                    }).catch((error) => {
                        scope.callback();
                    })
                }



                ////////////////////////////////////////////
                // Secret rotation
                ////////////////////////////////////////////
                scope.createNewSecret = () => {
                    var delay = 1000;
                    if (!scope.SECRET_ROTATION) {
                        scope.SECRET_ROTATION = true;
                        $timeout(() => {
                            scope.application.rotateSecret().then((application) => {
                                $timeout(() => {
                                    scope.application = application;
                                    $rootScope.$broadcast('APPLICATION_RELOAD_PAGE');
                                    scope.SECRET_ROTATION = false;
                                }, delay );
                            }).catch((error) => {

                            });
                        }, delay );
                    }
                }

                ////////////////////////////////////////////
                // Copy to clipboard
                ////////////////////////////////////////////
                scope.copyData = (stringData) => {
                    var data = stringData.split(' ')[0];
                    var input = document.createElement('input');
                    input.setAttribute('value', data);
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input)
                    var message = $filter("translate")("CopyToClipboard")

                    toastr.success(`${message}: ${data}`);
                }

                scope.markAll = function(event) {
                    var range = document.createRange();
                    range.selectNodeContents(event.currentTarget);
                    var selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                };

                scope.$on('$destroy', function() {
                    scope.application = null;
                });

            }
        };
        }

        pxApplicationDirective.$inject = [
            '$timeout', '$filter', 'toastr', '$http', 'ApplicationsService', 'RegexModel',
            '$rootScope'
        ];

        angular
        .module('printix-admin')
        .directive('pxApplicationDirective', pxApplicationDirective);

    })();
